export default {
  getUserPlatformRelationsByUser: '/api/role/getUserPlatformRelationsByUser', // 获取与平台绑定关系的用户列表
  getUserPlatformRelationsByPlatform: '/api/role/getUserPlatformRelationsByPlatform', //获取绑定关系的平台列表 ( 公司或项目 )
  setRelations: '/api/role/setRelations', // 写入绑定关系
  setRoleRelations: '/api/role/setRoleRelations', // 将绑定关系与角色关联 (用户与 [公司/项目]的绑定关系)
  setRoleRelationAll: '/api/role/setRoleRelationAll', // 批量将绑定关系与角色关联 (用户与 [公司/项目]的绑定关系)

  saveAutoAuthProjectByUser: '/api/role/saveAutoAuthProjectByUser', // 保存用户自动授权项目
  saveAutoAuthCompanyByUser: '/api/role/saveAutoAuthCompanyByUser', // 保存自动授权公司 (用户与公司的绑定关系)
  getAutoAuthByUser: '/api/role/getAutoAuthByUser', // 获取用户自动授权公司和项目
};
